import React from "react";
import { Modal } from 'react-bootstrap';
import { useEffect, useState } from "react";

const About:React.FC<propTypes> = (props: propTypes) => {
	const [flag, setFlag] = useState(false);

    useEffect(() => {
        if (window.innerWidth < 991) {
			setFlag(true);
		}
    }, []);

	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			className="confirm-modal"
			data-testid="about-modal"
		>
			<Modal.Header id="closebtn" closeButton style={{background:"#f4f4f4"}}>
				<Modal.Title id="title">
					<b>About</b>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className='text-center'>
				<div className={flag ? '' : 'm-2'}>
					<h4><b> Light pole Asset Management Portal (LAMP) v1.5</b></h4>
					<h5>Created by Walter P Moore for Katy ISD</h5>
					<div className={flag ? '' : 'desciption mx-4'}>
						<div className={`text text-start text-wrap ${flag ? 'ms-2':' ms-3'}`} style={{ marginTop: '1.8rem' }}>
							This portal provides pole information for select high schools, middle schools, elementary schools  and maintenance facilities along with the ability to select High, Medium, and Low Priority repair recommendations. Visual observations can be viewed within the portal or printed for one or more locations using the reporting feature.
							Pole information was collected February-April 2022 and October-November 2023.
						</div>
						<p className="mt-3" >
							For additional questions or comments, please email {''}
							<a href="mailto:lamp@walterpmoore.com">lamp@walterpmoore.com</a>
						</p>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

type propTypes = {
	show: boolean,
	onHide: () => void
};

export default About;